import { SortItem } from "./pagination";
import { Role } from "./permission";

// Role hierarchy levels - lower numbers mean higher privilege (matching backend)
export const ROLE_HIERARCHY_LEVELS: Record<Role, number> = {
  [Role.SystemAdmin]: 0,
  [Role.OrganizationOwner]: 1,
  [Role.OrganizationAdmin]: 2,
  [Role.Teacher]: 3
};

export const roleTranslations: Map<Role, string> = new Map<Role, string>([
  [Role.SystemAdmin, "role_system_admin"],
  [Role.OrganizationOwner, "role_organization_owner"],
  [Role.OrganizationAdmin, "role_organization_admin"],
  [Role.Teacher, "role_user"]
]);

// "user", "organization_admin" are the user roles expected in the backend
export enum UserFacingRoleNames {
  "Teacher" = "user",
  "Admin" = "organization_admin"
}

/**
 * Get available roles that the current user can assign based on their role level
 * Users can only assign roles at their level or lower (higher numbers)
 * Always excludes SystemAdmin role
 */
export function getAssignableRoles(currentUserRole: Role): Role[] {
  const currentUserLevel = ROLE_HIERARCHY_LEVELS[currentUserRole];
  return Object.entries(ROLE_HIERARCHY_LEVELS)
    .filter(([role, level]) => level >= currentUserLevel && role !== Role.SystemAdmin)
    .map(([role]) => role as Role);
}

export interface Breadcrumb {
  url: string;
  text: string;
  icon?: string;
  iconOnly?: boolean; // If true and using an icon, use text as alt text instead of displaying
}

export interface DataTableOptions {
  groupBy: { [key: string]: string }[];
  itemsPerPage: number;
  page: number;
  pageToken: string;
  search: string;
  sortBy: SortItem[];
}
